/**
 * Verification FSM helpers — Phase G5 CP3.
 *
 * Kept as tiny pure functions so tests can pin behavior without
 * standing up any React components.
 *
 * Backend FSM (CP1 dispatch, service.py):
 *   pending   → {approved, rejected}
 *   approved  → {active, pending}          "pending" = "Return to Review"
 *   active    → {approved}                 "approved" = "Temporarily Deactivate"
 *   rejected  → {pending}                  "pending" = "Reopen for Review"
 *
 * The `is_active` boolean is SEPARATE from `verification_status` — an
 * admin can flip a pro to `is_active=false` without touching verification.
 */

// Action definitions rendered on the ProfessionalDetail page.
// `next` is the next `verification_status`; `test_id` is the DOM hook the
// tester agent looks for; `requires_notes` means the client-side form MUST
// require verification_notes before submitting.
export const VERIFICATION_ACTIONS = {
  pending: [
    { key: "approve", label: "Approve", next: "approved", variant: "primary", test_id: "admin-verification-action-approve" },
    { key: "reject", label: "Reject", next: "rejected", variant: "destructive", requires_notes: true, test_id: "admin-verification-action-reject" },
  ],
  approved: [
    { key: "activate", label: "Activate", next: "active", variant: "primary", test_id: "admin-verification-action-activate" },
    { key: "return_to_review", label: "Return to Review", next: "pending", variant: "secondary", test_id: "admin-verification-action-return-to-review" },
  ],
  active: [
    { key: "deactivate_temporarily", label: "Temporarily Deactivate", next: "approved", variant: "secondary", test_id: "admin-verification-action-deactivate" },
  ],
  rejected: [
    { key: "reopen", label: "Reopen for Review", next: "pending", variant: "primary", test_id: "admin-verification-action-reopen" },
  ],
};

export function actionsForStatus(status) {
  return VERIFICATION_ACTIONS[status] || [];
}

// Colour tokens for the state pills.
export const STATUS_BADGE = {
  pending: { bg: "rgba(251,191,36,0.12)", fg: "#F59E0B", border: "rgba(251,191,36,0.4)", label: "Pending review" },
  approved: { bg: "rgba(96,165,250,0.12)", fg: "#60A5FA", border: "rgba(96,165,250,0.4)", label: "Approved (not live)" },
  active: { bg: "rgba(52,211,153,0.12)", fg: "#34D399", border: "rgba(52,211,153,0.4)", label: "Live" },
  rejected: { bg: "rgba(239,68,68,0.14)", fg: "#F87171", border: "rgba(239,68,68,0.42)", label: "Rejected" },
};

export function statusBadge(status) {
  return STATUS_BADGE[status] || STATUS_BADGE.pending;
}

// Category slug → display fallback (for chip labels when we don't have a
// category dictionary loaded yet).
export function labelForSlug(slug) {
  if (!slug) return "";
  return slug.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
